
import axios from '../axiosCall'
import Urls from "../endpoints";
import { ChangeStatusType, RestrictedCallType } from "../../types/RestrictedCall/Type";
import { getSearchedUserLinesAuthRequest, inquireNidRequest, rejectInquireNidRequest } from '../../types/useAuth/types';

export const acceptInquireNid = (id: string) => {
    return axios.post<boolean>(Urls.AcceptInquireNid(id))
}

export const inquireNid = (params:inquireNidRequest) => {
    return axios.post<boolean>(Urls.InquireNid(),params)
}

export const rejectInquireNid = (params:rejectInquireNidRequest) => {
        return axios.post<boolean>(Urls.RejectInquireNid(params?.id,params?.current,params?.reason))
}

export const rejectInquireNidByCustomerId = (params:rejectInquireNidRequest) => {
        return axios.post<boolean>(Urls.rejectInquireNidByCustomerIdFn(params?.id,params?.current,params?.reason))
}

export const getSearchedUserLinesAuthDataById = (id:string) => {
    return axios.get<getSearchedUserLinesAuthRequest>(Urls.GetSearchedUserLinesAuthDataById(id))
}



